import React, { useEffect } from 'react';

import LoadingIcon from 'icons/loading.svg';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

import ActivityTableHeaders from 'components/projectActivity/components/ActivityTableHeaders';
import ProjectActivityRow from 'components/projectActivity/components/ProjectActivityRow';
import ProjectMessageRow from 'components/projectActivity/components/ProjectMessageRow';

export default function ProjectActivityTable({
  hasMore,
  isActive,
  loadMore,
  messageInfo,
  projectHistories,
}) {
  const [ref, inView] = useInView();

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  useEffect(() => {
    isActive && hasMore && inView && loadMore();
  }, [isActive, hasMore, inView]);

  return (
    <>
      <table className='table handshq__table handshq__table--spaced handshq__table--middled tw-border-grey-100 tw-bg-white'>
        <thead className='handshq__thead'>
          <ActivityTableHeaders />
        </thead>
        <tbody className='handshq__tbody'>
          {projectHistories?.map((history) =>
            history.messageId ?
              <ProjectMessageRow
                history={history}
                key={history.id}
                message={messageInfo[history.messageId]}
              />
            : <ProjectActivityRow history={history} key={history.id} />,
          )}
        </tbody>
      </table>
      {hasMore && (
        <div
          className='handshq__tbody-loading-bar tw-apply-loading-spinner--grey-regular'
          ref={ref}
        >
          <LoadingIcon height={18} width={18} />
          <span className='tw-pl-[5px]'>{i18nTShared('loadingMore...')}</span>
        </div>
      )}
    </>
  );
}
